<template>
    <div class="businessBox" style="padding-top: 80px">
        <div class="titleBox">
            <div class="title">{{$t('lang.homePage.bendihYw')}}</div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="itemBox cl itemBoxmarbottom" @click="goToDetail('/product/powerAndHonor')">
                    <div class="fl imageBox">
                        <img src="../../assets/images/PowerandHonor.png" alt="" width="100%">
                    </div>
                    <div class="fl tswidth">
                        <!--<div class="item name">产品名</div>-->
                        <div class="item projectName">Power and Honor</div>
                        <div class="item name">{{ $t('lang.business.invasion.a2') }}</div>
                        <div class="item detail">{{ $t('lang.business.powerAndHonor.kaifashang') }}</div>
                    </div>
                </div>
            </div>
            <!--<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--<div class="itemBox cl itemBoxmarbottom" @click="goToDetail('/product/brutalAge')">-->
                    <!--<div class="fl imageBox">-->
                        <!--<img src="../../assets/images/BrutalAge.png" alt="" width="100%">-->
                    <!--</div>-->
                    <!--<div class="fl">-->
                        <!--<div class="item name">产品名</div>-->
                        <!--<div class="item detail" style="margin-bottom: 20px">{{ $t('lang.business.brutalAge.name') }}</div>-->
                        <!--<div class="item name">开发商</div>-->
                        <!--<div class="item detail">Tap4Fun</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="itemBox cl itemBoxmarbottom" @click="goToDetail('/product/thisNew')">
                    <div class="fl imageBox">
                        <img src="../../assets/images/ThisNew.png" alt="" width="100%">
                    </div>
                    <div class="fl">
                        <!--<div class="item name">产品名</div>-->
                        <div class="item projectName">This New</div>
                        <div class="item name">{{ $t('lang.business.invasion.a2') }}</div>
                        <div class="item detail">{{ $t('lang.business.thisNew.kaifashang') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
        <!--    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="itemBox cl itemBoxmarbottom" @click="goToDetail('/product/gameOfKings')">
                    <div class="fl imageBox">
                        <img src="../../assets/images/GameofKings.png" alt="" width="100%">
                    </div>
                    <div class="fl">
                        <div class="item name">产品名</div>
                        <div class="item detail" style="margin-bottom: 20px">{{ $t('lang.business.gameOfKings.name') }}</div>
                        <div class="item name">开发商</div>
                        <div class="item detail">{{ $t('lang.business.gameOfKings.kaifashang') }}</div>
                    </div>
                </div>
            </div>-->
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div class="itemBox cl itemBoxmarbottom" @click="goToDetail('/product/warOfSteel')">
                    <div class="fl imageBox">
                        <img src="../../assets/images/WarofSteel.png" alt="" width="100%">
                    </div>
                    <div class="fl">
                        <!--<div class="item name">产品名</div>-->
                        <div class="item projectName">{{ $t('lang.business.warOfSteel.name') }}</div>
                        <div class="item name">{{ $t('lang.business.invasion.a2') }}</div>
                        <div class="item detail">{{ $t('lang.business.warOfSteel.kaifashang') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!--<div class="row">-->
            <!--<div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">-->
                <!--<div class="itemBox cl itemBoxmarbottom" @click="goToDetail('/product/warOfSteel')">-->
                    <!--<div class="fl imageBox">-->
                        <!--<img src="../../assets/images/WarofSteel.png" alt="" width="100%">-->
                    <!--</div>-->
                    <!--<div class="fl">-->
                        <!--<div class="item name">产品名</div>-->
                        <!--<div class="item detail" style="margin-bottom: 20px">{{ $t('lang.business.warOfSteel.name') }}</div>-->
                        <!--<div class="item name">开发商</div>-->
                        <!--<div class="item detail">{{ $t('lang.business.warOfSteel.kaifashang') }}</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    export default {
        name: "business",
        mounted(){
            document.getElementsByTagName('html')[0].scrollTop=0;
            // window.location.reload();
        },
        methods: {
            goToDetail(path) {
                this.$router.push(path)
            }
        },
    }
</script>

<style scoped>
.businessBox{
    width: 80%;
    margin: 0 auto;
}
/**/
.businessBox .titleBox{
    height: 2px;
    background: #d1d1d1;
    position: relative;
    margin: 100px 0;
}
.businessBox .titleBox .title{
    width: 300px;
    background: #fff;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: -25px;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 8px;
    color: #020202;
}
.businessBox .itemBox{
    cursor: pointer;
    box-shadow: 0 0 30px 0 rgba(0,0,0,.08);
    border-radius: 18px;
    padding: 20px;
}

.businessBox .itemBox.itemBoxmarbottom{
    margin-bottom: 140px;
}
    .businessBox .itemBox .imageBox{
        width: 154px;
        height: 154px;
        border-radius: 33px;
        background: #bdbcb5;
        margin-right: 15px;
        overflow: hidden;
    }
    .businessBox .itemBox .tswidth{
        width: 60%;
    }
.businessBox .itemBox .name{
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    margin-bottom: 13px;
    line-height: 20px;
}
.businessBox .itemBox .projectName{
    font-size: 28px;
    font-weight: bold;
    color: #000000;
    line-height: 20px;
    margin: 0 0 30px;
}
.businessBox .itemBox .detail{
    font-size: 23px;
    font-weight: bold;
    color: #000000;
    line-height: 20px;
}
/*@media (max-width: 992px){*/
    /*.businessBox .itemBox .imageBox{*/
        /*width: 110px;*/
        /*height: 110px;*/
        /*border-radius: 23px;*/
        /*background: #bdbcb5;*/
        /*margin-right: 15px;*/
    /*}*/
/*}*/
@media (max-width: 992px){
    .businessBox .itemBox .imageBox{
        width: 24%;
        height: auto;
        border-radius: 16px;
        background: #bdbcb5;
        margin-right: 15px;
        margin-top: 2px;
    }
    .businessBox .itemBox .projectName{
       font-size: 20px;
        margin: 0 0 10px;
    }
    .businessBox .itemBox .name{
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        margin-bottom: 0;
        line-height: 20px;
    }
    .businessBox .itemBox .detail{
        font-size: 18px;
        font-weight: bold;
        color: #000000;
        line-height: 20px;
    }
    .businessBox .itemBox.itemBoxmarbottom{
        margin-bottom: 100px;
    }
    .businessBox .itemBox .tswidth{
        width: 70%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/product/business.vue